import React, { useState } from 'react';

export default function Footer() {

    const [shown, setShown] = useState(false);

    return (
        <>
            <footer className="footer pt-3  ">
                <div className="container-fluid">
                    <div className="row align-items-center justify-content-lg-between">
                        <div className="col-lg-6 mb-lg-0 mb-4">
                            <div className="copyright text-center text-sm text-muted text-lg-start">
                                
                            </div> 
                        </div>
                    </div>
                </div>
            </footer>   
        </>
    )
}
